import { createContext, FocusEventHandler, useContext } from 'react'

import { isNil } from 'lodash-es'

import { PickupDeliveryLocationResponseV1 } from '@forto-dev/customer-master-data-models'

export type LocationSelectorDispatchContextState = {
  onSelect?: (selectedLocation: PickupDeliveryLocationResponseV1 | null) => void
  onAddNew: () => void
  onAddNewCompleted: (newLocation?: PickupDeliveryLocationResponseV1) => void
  onBlur?: FocusEventHandler<HTMLDivElement>
}

export const LocationSelectorDispatchContext = createContext<LocationSelectorDispatchContextState | null>(null)

export const useLocationSelectorDispatchContext = (): LocationSelectorDispatchContextState => {
  const ctx = useContext(LocationSelectorDispatchContext)

  if (isNil(ctx)) {
    throw new Error('useLocationSelectorDispatchContext must be used within a LocationSelectorDispatchContext.Provider')
  }

  return ctx
}
